export interface IServicesDataValidation {
    minimumNddAge: boolean;
    maximumNddAge: boolean;
}